export default __webpack_public_path__ + "static/media/codart.c4e9584c.jpg";